import React from 'react';
import { BanknoteIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { PRICE, TOMOS_VALUE, BONOS_VALUE, TOTAL_VALUE, SAVINGS, DISCOUNT } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['Tomo 1: 40 recetas con costo por pieza', 'Tomo 2: 6 menús para 10, 20 y 30 personas', 'Tomo 3: plan de 30 días para tus primeros pedidos', 'Los 5 bonos (4 en PDF y 1 en Excel)'];
const valueRows = [{
  label: '3 tomos principales',
  value: TOMOS_VALUE
}, {
  label: '5 bonos',
  value: BONOS_VALUE
}];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: BanknoteIcon,
  label: 'Tarjeta o pago local'
}];
type OfferProps = {
  showUrgency?: boolean;
};
export function Offer({
  showUrgency = true
}: OfferProps) {
  return <section id="oferta" className="bg-sand py-20 sm:py-28 space-y-[12px]" aria-labelledby="oferta-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-140" data-mp="pkqls41ypj74">
      <div className="mx-auto max-w-5xl px-6" data-id="element-141" data-mp="ul4yhzeidhbh">
        {showUrgency ? <Reveal data-id="element-142" data-mp="zjpufmmq9eu4">
            <div className="rounded-3xl bg-cream px-6 py-10 sm:px-12" data-id="element-143" data-mp="zgagin4sibua">
              <CountdownTimer label="PRECIO ESPECIAL DE LANZAMIENTO" note={`Hoy ${PRICE} en lugar de ${TOTAL_VALUE}.`} data-id="element-144" data-mp="13ip0jak73hn5" />
            </div>
          </Reveal> : null}

        <Reveal className={showUrgency ? 'mt-16' : ''} data-id="element-145" data-mp="bskgxe49eymz">
          <div className="text-center" data-id="element-146" data-mp="bt2ag2zjeyr7">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-147" data-mp="funv4aibchby">
              Llévate Catering para Emprender completo
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-148" data-mp="3k8vrqk1p0e9b">
              Los 3 tomos y los 5 bonos en un solo pago.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-149" data-mp="3o8ee7k95wxe9">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-cream-line bg-white shadow-lift" data-id="element-150" data-mp="vfqv3wjgh2pk">
            <p className="bg-mint-700 py-2.5 text-center text-sm font-semibold uppercase tracking-[0.16em] text-white" data-id="element-151" data-mp="qhfnlsgmv4ai">
              Todo incluido · acceso inmediato
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-152" data-mp="106pc6yc9q4tv">
              <div data-id="element-153" data-mp="cgmth8u8ub7x">
                <h3 className="font-display text-3xl text-ink" data-id="element-154" data-mp="chxsywgnowt8">Pack completo</h3>
                <ul className="mt-6 space-y-3" data-id="element-155" data-mp="7ibfqn0tvgkf">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-156" data-mp="7k4pwcangix6">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-700" aria-hidden="true" data-id="element-157" data-mp="lj4a97r4qbnj" />
                      <span className="text-[15px] text-ink-soft" data-id="element-158" data-mp="heo73e8whic0">{item}</span>
                    </li>)}
                </ul>

                <dl className="mt-8 space-y-2 border-t border-cream-line pt-6 text-sm" data-id="element-159" data-mp="1wykjy64cm3cm">
                  {valueRows.map(row => <div key={row.label} className="flex justify-between gap-4" data-id="element-160" data-mp="20ex8s33r7vv3">
                      <dt className="text-ink-muted" data-id="element-161" data-mp="20h09bh2j97e2">{row.label}</dt>
                      <dd className="text-ink-soft" data-id="element-162" data-mp="25fbj5rstvhwa">{row.value}</dd>
                    </div>)}
                  <div className="flex justify-between gap-4 font-semibold text-ink" data-id="element-163" data-mp="1qhrfqpbkxus8">
                    <dt data-id="element-164" data-mp="1vglwzmtwfba8">Valor total</dt>
                    <dd data-id="element-165" data-mp="1vhnd45prunyt">{TOTAL_VALUE}</dd>
                  </div>
                </dl>
              </div>

              <div className="flex flex-col" data-id="element-166" data-mp="2j7hn8fiphyfd">
                <p className="text-sm text-ink-muted line-through" data-id="element-167" data-mp="2o36piqm41tfd">{TOTAL_VALUE}</p>
                <p className="mt-1 font-display text-6xl leading-none text-mint-700" style={{
                fontSize: "56px"
              }} data-id="element-168" data-mp="29fvh2xl86pjh">
                  {PRICE}
                </p>
                <p className="mt-4 inline-flex w-fit flex-wrap items-center gap-1 rounded-full bg-terra-light px-3 py-1.5 text-sm font-semibold text-terra-dark" data-id="element-169" data-mp="3249d57sr7bse">
                  Ahorras {SAVINGS} · {DISCOUNT} de descuento
                </p>

                <div className="mt-8" data-id="element-170" data-mp="1j7zbwkd5ctzu">
                  <CtaButton className="w-full" data-id="element-171" data-mp="1e7bbj83130sy">Quiero empezar a vender</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-172" data-mp="197yoam88vrpu">
                  El precio está expresado en dólares estadounidenses (USD). El cobro se hace automáticamente en la moneda de tu país al tipo de cambio del momento.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-173" data-mp="1wyuexg0ysgvi">
          <div className="mx-auto mt-10 max-w-3xl" data-id="element-174" data-mp="1wzw04dbp2jqy">
            <p className="text-center text-sm font-medium text-ink" data-id="element-175" data-mp="1s6ax26v8uzkw">
              Pagas en tu moneda local
            </p>

            <ul className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-176" data-mp="1n7gi5g0edv62">
              {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-177" data-mp="2koye9b74dugp">
                  <item.icon className="h-4 w-4 text-mint-700" aria-hidden="true" data-id="element-178" data-mp="2fuu6wqtxzkf3" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}